const select = {
  Select: {
    baseStyle: {
      icon: {
        height: "24px",
        width: "24px",
      },
    },
    variants: {
      outline: {
        field: {
          h: '40px',
          borderColor: 'neutral.90',
          fontSize: '14px',
          fontWeight: '400',
          color:'neutral.90',
          _hover: {
            borderColor: 'neutral.90',
          },
          _disabled: {
            borderColor: 'neutral.90',
            bg: 'grey.50',
            opacity: 1,
            color: 'neutral.110'
          },
          _invalid: {
            borderColor: 'destructive.400',
            boxShadow: '0'
          }
        }
      },
      flag: {
        field: {
          h: '40px',
          border: '1px solid',
          paddingLeft: '35px',
          bg: 'transparent'
        },
      }
    }
  }
}

export default select
